import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useDaily, useLocalParticipant, useAudioTrack, useDailyEvent } from '@daily-co/daily-react';
import {
  MicrophoneOn,
  ChatIcon,
  FaceTrackingButton,
  NftButton,
  ReactionButton,
  ViewCountOFF,
  SpeakerButton,
  EditNameButton,
  BackgroundButton,
  SettingButton,
} from './Icons';
import {
  webcamAtom,
  pageAtom,
  topMessageAtom,
  screenShareAtom,
  myMuteAtom,
  recordLocalAtom,
  playAudioAtom,
  recordTypeAtom,
  showEditNameAtom,
} from '../../State';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import Chat from '../Chat/Chat';
import './Tray.css';
import { ReactComponent as HangOutSVG } from '../Images/buttons/hangoutButton.svg';
import { ReactComponent as ExitSVG } from '../Images/buttons/exitButton.svg';
import CountDown from '../Header/CountDown';
import { isMobile, useMobileOrientation } from 'react-device-detect';
import isElectron from '../../Global';
import TrayScreenShare from './TrayScreenShare';
import TrayRecord from './TrayRacord';
import AddAccess from '../Util/AddAccess';
import LiveList from '../Live/LiveList';
import Live from '../Live/Live';
import { useTranslation } from 'react-i18next';

export default function Tray({
  leaveCall,
  isHairCheck = false,
  isLiveViewer,
  isLive,
  isRecording = false,
  isFaceScreen = false,
}) {
  //Daily系
  const callObject = useDaily();
  const localParticipant = useLocalParticipant();
  const localAudio = useAudioTrack(localParticipant?.session_id);
  const mutedAudio = localAudio.isOff;
  const { t } = useTranslation();

  //Recoil系
  const [webcamState, setWebcamState] = useRecoilState(webcamAtom);
  const setPageState = useSetRecoilState(pageAtom);
  const setMyMuteState = useSetRecoilState(myMuteAtom);
  const [recordType, setRecordTypeState] = useRecoilState(recordTypeAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const setShowEditName = useSetRecoilState(showEditNameAtom);
  const screenShareState = useRecoilValue(screenShareAtom);
  const [recordLocalState, setRecordLocalState] = useRecoilState(recordLocalAtom);

  //その他
  const [showChat, setShowChat] = useState(false);
  const [showMemberList, setShowMemberList] = useState(false);
  const [newChatMessage, setNewChatMessage] = useState(false);
  const [mouseState, setMouseState] = useState(false);
  const orientation = useMobileOrientation();

  //チャット受信
  useDailyEvent(
    'app-message',
    useCallback(
      (ev) => {
        if (ev.data.type == 'chat') {
          /* Only light up the chat icon if the chat isn't already open. */
          if (!showChat) {
            setNewChatMessage(true);

            //メッセージお知らせ通知

            if (isLive == false) {
              setTopMessageState({
                type: 'joined',
                message: <>{t('top.You got a message')}</>,
              });
            }
          }
        }
      },
      [showChat],
    ),
  );

  //オリエンテーション
  useEffect(() => {}, [orientation]);

  //ミュートボタン押した時
  const toggleAudio = useCallback(
    (e) => {
      if (mutedAudio) {
        setMyMuteState(false);
      } else {
        setMyMuteState(true);
      }

      //アクセス
      AddAccess('click', 'mute', mutedAudio);

      if (callObject != null) {
        callObject.setLocalAudio(mutedAudio);
      }
    },
    [callObject, mutedAudio],
  );

  //チャット
  const toggleChat = () => {
    setShowChat(!showChat);
    if (newChatMessage) {
      setNewChatMessage(!newChatMessage);
    }

    if (showMemberList) {
      setShowMemberList(false);
    }

    //アクセス
    AddAccess('click', 'chat', showChat);
  };

  //メンバーリスト
  const toggleMemberList = (status) => {
    setShowMemberList(!showMemberList);

    if (showChat) {
      setShowChat(false);
    }

    //アクセス
    AddAccess('click', 'memberList', showMemberList);
  };

  //NFTボタン
  const toggleNFT = () => {
    setPageState('nftList');
  };

  //顔認識のON/OFF
  const toggleFaceTrack = () => {
    if (callObject == null && isFaceScreen == false) {
      return;
    }
    //ウェブカメラをストップ
    setWebcamState(!webcamState);
    //setShowChat(!faceTrackState);

    //アクセス
    AddAccess('click', 'camera', webcamState);
  };

  const handleMouseEnter = (e) => {
    if (screenShareState != null) {
      setMouseState(true);
    }
  };
  const handleMouseLeave = (e) => {
    if (screenShareState != null) {
      setMouseState(false);
    }
  };

  const showEditName = () => {
    setShowEditName(true);
  };

  //コール終了
  const endCall = () => {
    //レコーディングされていたら保存する

    if (recordLocalState) {
      if (recordType == 'cloud') {
        //var result = window.confirm('Plese stop recording before leaving room');
        alert(t('bottom.Please stop recording, before leaving room'));
        return;
      }

      setRecordLocalState(false);
    }

    if (isMobile) {
      let status = window.confirm(t('bottom.Are you leaving call?'));
      if (status == false) {
        return;
      }
    }

    leaveCall();

    //アクセス
    AddAccess('click', 'endCall');
  };

  //プレJoin画面
  const renderHairCheckBottom = () => {
    return (
      <div className="tray" style={{ position: 'relative' }}>
        <div className="tray-buttons-container" style={{ padding: 0 }}>
          <div></div>
          <div
            className="actions"
            // style={{
            //   position: 'absolute',
            //   top: '50%',
            //   left: '50%',
            //   transform: 'translate(calc(-50% - 250px), -50%)',
            // }}
          >
            <MicrophoneOn toggleAudio={toggleAudio} isOn={mutedAudio} isHairCheck={isHairCheck} />
            <FaceTrackingButton
              toggleFaceTrack={toggleFaceTrack}
              isOn={!webcamState}
              isHairCheck={isHairCheck}
            />
            <button onClick={toggleNFT}>
              <NftButton />
            </button>

            <button
              onClick={() => {
                setPageState('background');
              }}>
              <BackgroundButton />
            </button>

            <button
              onClick={() => {
                setPageState('setting');
              }}>
              <SettingButton />
            </button>
          </div>
          <div></div>
        </div>
      </div>
    );
  };

  //メイン画面
  const renderCallBottom = () => {
    return (
      <>
        {/* チャット*/}
        <Chat showChat={showChat} toggleChat={toggleChat} />
        <div
          className="tray"
          style={{
            opacity: screenShareState != null && mouseState == false ? 0 : 1,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          {/* メンバーリスト*/}
          <LiveList showMemberList={showMemberList} toggleMemberList={toggleMemberList} />
          <div className="tray-buttons-container">
            <div className="controls">
              {/* {isLive && isLiveViewer == false && (
              <button onClick={toggleMemberList}>
                <ViewCountOFF />
              </button>
            )} */}
            </div>
            <div className="actions">
              <MicrophoneOn toggleAudio={toggleAudio} isOn={mutedAudio} />
              <FaceTrackingButton toggleFaceTrack={toggleFaceTrack} isOn={!webcamState} />
              <TrayScreenShare />
              <button onClick={toggleNFT}>
                <NftButton />
              </button>
              <TrayRecord isLive={isLive} />
              <button onClick={toggleChat}>
                {newChatMessage && <div id="chatBadge"></div>}
                <ChatIcon />
              </button>
              {/* <ReactionButton /> */}

              <button onClick={toggleMemberList}>
                <ViewCountOFF />
              </button>
            </div>
            <div className="leave">
              <button onClick={endCall} className="leaveArea">
                <HangOutSVG />
                <CountDown leaveCall={endCall} />
                {/* <div className="iconName">End Call</div> */}
                {/* <div id="countdownArea" className="countdown iconName">
                00: <span id="countdown-min">00</span>:<span id="countdown-sec">00</span>
              </div> */}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  //フェイス選択専用
  const renderFaceScreenBottom = () => {
    return (
      <>
        {/* チャット*/}
        <Chat showChat={showChat} toggleChat={toggleChat} />
        <div
          className="tray"
          style={{
            opacity: screenShareState != null && mouseState == false ? 0 : 1,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          {/* メンバーリスト*/}
          <LiveList showMemberList={showMemberList} toggleMemberList={toggleMemberList} />
          <div className="tray-buttons-container">
            <div className="controls">
              {/* {isLive && isLiveViewer == false && (
                <button onClick={toggleMemberList}>
                  <ViewCountOFF />
                </button>
              )} */}
            </div>
            <div className="actions">
              <MicrophoneOn toggleAudio={toggleAudio} isOn={false} />
              <FaceTrackingButton toggleFaceTrack={toggleFaceTrack} isOn={!webcamState} />
              <button onClick={toggleNFT}>
                <NftButton />
              </button>
              <button
                onClick={() => {
                  setPageState('background');
                }}>
                <BackgroundButton />
              </button>

              <button
                onClick={() => {
                  setPageState('setting');
                }}>
                <SettingButton />
              </button>
            </div>
            <div className="leave"></div>
          </div>
        </div>
      </>
    );
  };

  //録画用ボトム
  const renderRecordingBottom = () => {
    return (
      <>
        {/* チャット*/}
        <Chat showChat={showChat} toggleChat={toggleChat} />
        <div
          className="tray"
          style={{
            opacity: screenShareState != null && mouseState == false ? 0 : 1,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          {/* メンバーリスト*/}
          <LiveList showMemberList={showMemberList} toggleMemberList={toggleMemberList} />
          <div className="tray-buttons-container">
            <div className="controls">
              {/* {isLive && isLiveViewer == false && (
              <button onClick={toggleMemberList}>
                <ViewCountOFF />
              </button>
            )} */}
            </div>
            <div className="actions">
              <MicrophoneOn toggleAudio={toggleAudio} isOn={mutedAudio} />
              <FaceTrackingButton toggleFaceTrack={toggleFaceTrack} isOn={!webcamState} />
              <TrayScreenShare />
              <button onClick={toggleNFT}>
                <NftButton />
              </button>

              <button
                onClick={() => {
                  setPageState('background');
                }}>
                <BackgroundButton />
              </button>

              <button
                onClick={() => {
                  setPageState('setting');
                }}>
                <SettingButton />
              </button>
              <TrayRecord isLive={isLive} />
            </div>
            <div className="leave">
              <button onClick={endCall} className="leaveArea">
                <ExitSVG />
                <CountDown leaveCall={endCall} />
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  //ライブビューワー
  const renderLiveViewerBottom = () => {
    return (
      <>
        {/* チャット*/}
        <Chat showChat={showChat} toggleChat={toggleChat} />
        <div
          className="tray"
          style={{
            opacity: screenShareState != null && mouseState == false ? 0 : 1,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          {/* メンバーリスト*/}
          <LiveList showMemberList={showMemberList} toggleMemberList={toggleMemberList} />
          <div className="tray-buttons-container" style={{ padding: 0 }}>
            <div></div>
            <div className="actions">
              <button onClick={toggleMemberList}>
                <ViewCountOFF />
              </button>
              <button onClick={toggleChat}>
                {newChatMessage && <div id="chatBadge"></div>}
                <ChatIcon />
              </button>
              <SpeakerButton />
            </div>
            <div className="leave">
              <button onClick={endCall} className="leaveArea">
                <HangOutSVG />
                <CountDown leaveCall={endCall} />
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  //ライブビューワー
  const renderLiveViewerMobileBottom = () => {
    return (
      <>
        {/* チャット*/}
        <Chat showChat={showChat} toggleChat={toggleChat} />
        <div
          className="tray"
          // style={{
          //   opacity: screenShareState != null && mouseState == false ? 0 : 1,
          // }}
          //onMouseEnter={handleMouseEnter}
          //onMouseLeave={handleMouseLeave}
        >
          {/* メンバーリスト*/}
          <LiveList showMemberList={showMemberList} toggleMemberList={toggleMemberList} />
          <div
            className="tray-buttons-container tray-buttons-container_mobile"
            style={{ padding: 0 }}>
            <div className="mobileBottomButtons">
              <button onClick={toggleMemberList}>
                <ViewCountOFF />
              </button>
              <button onClick={toggleChat}>
                {newChatMessage && <div id="chatBadge"></div>}
                <ChatIcon />
              </button>

              <button onClick={endCall} className="leaveArea">
                <HangOutSVG />
                <CountDown leaveCall={endCall} />
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  //モバイル画面
  const renderMobileBottom = () => {
    return (
      <>
        {/* チャット*/}
        <Chat showChat={showChat} toggleChat={toggleChat} />
        <div
          className="tray"
          // style={{
          //   opacity: mouseState == false ? 0 : 1,
          // }}
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}
        >
          {/* メンバーリスト*/}
          <LiveList showMemberList={showMemberList} toggleMemberList={toggleMemberList} />
          <div
            className="tray-buttons-container tray-buttons-container_mobile"
            style={{ padding: 0 }}>
            <div className={isHairCheck ? 'mobileBottomButtons' : 'mobileBottomButtonsCall'}>
              <MicrophoneOn toggleAudio={toggleAudio} isOn={mutedAudio} />
              {!isHairCheck && (
                <>
                  <button onClick={toggleMemberList}>
                    <ViewCountOFF />
                  </button>
                </>
              )}
              <button onClick={toggleNFT}>
                <NftButton />
              </button>
              {!isHairCheck && (
                <>
                  <button onClick={toggleChat}>
                    {newChatMessage && <div id="chatBadge"></div>}
                    <ChatIcon />
                  </button>
                  <button onClick={endCall} className="leaveArea">
                    <HangOutSVG />
                    <CountDown leaveCall={endCall} />
                  </button>
                </>
              )}
              {isHairCheck && (
                <button onClick={showEditName}>
                  <EditNameButton />
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  if (isFaceScreen) {
    return renderFaceScreenBottom();
  } else if (isRecording) {
    return renderRecordingBottom();
  } else if (isLiveViewer) {
    if (isHairCheck) {
      return false;
    } else {
      if (isMobile) {
        return renderLiveViewerMobileBottom();
      } else {
        return renderLiveViewerBottom();
      }
    }
  } else if (isMobile && isHairCheck) {
    return renderMobileBottom();
  } else if (isMobile) {
    return renderMobileBottom();
  } else if (isHairCheck) {
    return renderHairCheckBottom();
  } else {
    return renderCallBottom();
  }
}
